import { fetchAssets } from '../api/dataInputApi';
import { useAutocompleteData } from './useAutocompleteData';

export const useAssetSelector = () => {
  return useAutocompleteData('assets', fetchAssets);
};
